import endpointsPaths from "../endpointsPaths/endpointsPaths";
import httpRequest from "../httpRequest";
import httpRequestsPaths from "@helpers/httpRequestsPaths/httpRequestsPaths";

export const validateCodigoDescuentoConvenio = async (codigoDescuento) => {
  return new Promise(async (resolve, reject) => {
    try {
      const codigoValido = await httpRequest({
        url: `${endpointsPaths.convenios}/${httpRequestsPaths.convenios.uveg.validateCodigoDescuento}`,
        method: "POST",
        body: JSON.stringify({codigoDescuento})
      });

      resolve(codigoValido);
    } catch (error) {
      // console.log("Error al obtener las preguntas diagnóstico: ", error);

      reject(error);
    }
  });
};


export const deactivateDescuentoConvenio = async (codigoDescuento, folioContrato) => {
  return new Promise(async (resolve, reject) => {
    try {
      const codigoValido = await httpRequest({
        url: `${endpointsPaths.convenios}/${httpRequestsPaths.convenios.uveg.deactivateCodigoDescuento}/${codigoDescuento}`,
        method: "POST",
        body: JSON.stringify({folioContrato})
      });

      resolve(codigoValido);
    } catch (error) {
      // console.log("Error al obtener las preguntas diagnóstico: ", error);

      reject(error);
    }
  });
};

export const validarHayConvenio = async (folioContrato) => {
  return new Promise(async (resolve, reject) => {
    try {
      const codigoValido = await httpRequest({
        url: `${endpointsPaths.convenios}/${httpRequestsPaths.convenios.uveg.validateFolioContrato}/${folioContrato}`,
        method: "POST",
      });

      resolve(codigoValido);
    } catch (error) {
      // console.log("Error al obtener las preguntas diagnóstico: ", error);

      reject(error);
    }
  });
};